<page-toolbar [title]="title"></page-toolbar>

<page-content>
  <div class="form-container">
    <ng-template formHost></ng-template>
  </div>

  <button (click)="onSave()" mat-button>Save</button>
</page-content>

